import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLocale } from '../components/LocaleProvider';
import { SiteLayout } from '../components/SiteLayout';
import { departments, drinkFamilies } from '../data/departments';
import { company } from '../data/company';
export function CategoryPage() {
  const {
    locale
  } = useLocale();
  const t = locale === 'nl' ? {
    eyebrow: 'Alle afdelingen',
    title: 'Een complete hypermarkt onder één dak.',
    intro: `De volledige afdelingengids van ${company.name}: verse voeding, dagelijkse basics, elektro, huis, familie, doe-het-zelf en professionele levering.`,
    drinks: 'Uitgelicht — dranken',
    drinksTitle: 'Verfrissing voor elk rek, elke tafel en elk moment.',
    drinksCopy: 'Een compleet aanbod voor dagelijkse boodschappen, horeca en professionals: gekoeld water, frisdranken, warme dranken, wijnen en sterkedrank.',
    families: 'drankenfamilies',
    brands: 'merkopties',
    request: 'Informatie aanvragen',
    imageAlt: 'Afdeling gekoelde dranken in onze Carrefour-winkel in Brugge',
    directory: 'Afdelingen A–Z',
    count: 'afdelingen'
  } : {
    eyebrow: 'All departments',
    title: 'A complete hypermarket under one roof.',
    intro: `The full ${company.name} directory: fresh food, everyday essentials, electricals, home, family, DIY and professional supply.`,
    drinks: 'Featured — drinks',
    drinksTitle: 'Refresh every shelf, table and occasion.',
    drinksCopy: 'A complete range for everyday shopping, hospitality and professionals: chilled water, soft drinks, hot drinks, wines and spirits.',
    families: 'drink families',
    brands: 'brand options',
    request: 'Request information',
    imageAlt: 'Chilled drinks department at our Carrefour store in Bruges',
    directory: 'Departments A–Z',
    count: 'departments'
  };
  return <SiteLayout data-id="element-67" data-mp="2bce4fe45z33p">
      <main data-id="element-68" data-mp="2bc4gdw2oj60n">
        <section className="border-b border-ink" data-id="element-69" data-mp="2bcmjncnreki2">
          <div className="mx-auto max-w-[1500px] px-5 py-16 lg:px-10 lg:py-20" data-id="element-70" data-mp="2baa0iw69m43f">
            <p className="font-mono text-[11px] uppercase tracking-label text-cobalt" data-id="element-71" data-mp="1xc3figmezyl6">
              {t.eyebrow}
            </p>
            <h1 className="mt-8 max-w-[20ch] font-display text-[2.75rem] leading-[0.98] tracking-[-0.03em] sm:text-6xl" data-id="element-72" data-mp="22div3t5tpcw6">
              {t.title}
            </h1>
            <p className="mt-8 max-w-2xl text-lg leading-8 text-ink/70" data-id="element-73" data-mp="1sf35jumg2bos">
              {t.intro}
            </p>
          </div>
        </section>

        {/* Featured drinks */}
        <section id="beverages-wine-and-spirits" className="scroll-mt-24 border-b border-ink" data-id="element-74" data-mp="1ioqo4b9xeymv">
          <div className="mx-auto grid max-w-[1500px] lg:grid-cols-[1fr_1fr]" data-id="element-75" data-mp="14ofvb2p239z2">
            <div className="bg-ink px-5 py-16 text-paper lg:px-12 lg:py-20" data-id="element-76" data-mp="19lz9k2lr7mr0">
              <p className="font-mono text-[11px] uppercase tracking-label text-cobalt" data-id="element-77" data-mp="q0pb04nzkvxr">
                {t.drinks}
              </p>
              <h2 className="mt-6 max-w-[20ch] font-display text-4xl leading-[1.04] tracking-[-0.02em] sm:text-5xl" data-id="element-78" data-mp="l3p45rjbbp5l">
                {t.drinksTitle}
              </h2>
              <p className="mt-6 max-w-md leading-8 text-paper/65" data-id="element-79" data-mp="v028djchhlel">
                {t.drinksCopy}
              </p>
              <dl className="mt-10 grid grid-cols-2 border-t border-paper/15 pt-6" data-id="element-80" data-mp="18z1no0e3wny3">
                <div data-id="element-81" data-mp="141rxgiiw8897">
                  <dt className="font-display text-3xl" data-id="element-82" data-mp="1408eul9rll49">8</dt>
                  <dd className="mt-2 font-mono text-[10px] uppercase tracking-label text-paper/55" data-id="element-83" data-mp="1iqfqah1cu3vg">
                    {t.families}
                  </dd>
                </div>
                <div className="border-l border-paper/15 pl-6" data-id="element-84" data-mp="1rqkmdv13lfub">
                  <dt className="font-display text-3xl" data-id="element-85" data-mp="1rr4358f0hy6r">100+</dt>
                  <dd className="mt-2 font-mono text-[10px] uppercase tracking-label text-paper/55" data-id="element-86" data-mp="1npsd51s87ay1">
                    {t.brands}
                  </dd>
                </div>
              </dl>
              <Link to="/contact" className="mt-10 inline-block border border-paper bg-paper px-6 py-4 font-mono text-[11px] uppercase tracking-[0.16em] text-ink transition hover:border-cobalt hover:bg-cobalt hover:text-paper" data-id="element-87" data-mp="3m69ihd9b5cjk">
                {t.request}
              </Link>
            </div>
            <img src="https://images.unsplash.com/photo-1534353473418-4cfa6c56fd38?auto=format&fit=crop&w=1400&q=95" alt={t.imageAlt} className="h-full min-h-[320px] w-full object-cover" data-id="element-88" data-mp="2yaf2q7rupzj5" />
          </div>
          <div className="mx-auto grid max-w-[1500px] border-t border-stone sm:grid-cols-2 lg:grid-cols-4" data-id="element-89" data-mp="3c94zfmardx6z">
            {drinkFamilies.map(item => <article key={item.name.nl} className="group border-b border-r border-stone bg-chalk last:border-r-0" data-id="element-90" data-mp="nivng5phf7s5">
                <div className="overflow-hidden border-b border-stone" data-id="element-91" data-mp="2bzdoiwh6g56m">
                  <img src={item.image} alt={item.name[locale]} loading="lazy" className="h-44 w-full object-cover transition duration-700 group-hover:scale-[1.04]" data-id="element-92" data-mp="27yble4k538zd" />
                </div>
                <div className="p-6" data-id="element-93" data-mp="1t9p6g3yfcj8o">
                  <h3 className="font-display text-xl" data-id="element-94" data-mp="1taqiaan9l9rg">{item.name[locale]}</h3>
                  <p className="mt-2 font-mono text-[10px] uppercase leading-5 tracking-label text-ink/45" data-id="element-95" data-mp="1oakyfgn8krjx">
                    {item.detail[locale]}
                  </p>
                </div>
              </article>)}
          </div>
        </section>

        {/* Directory */}
        <section data-id="element-96" data-mp="3entm32qcszl3">
          <div className="mx-auto max-w-[1500px] px-5 py-16 lg:px-10" data-id="element-97" data-mp="3em8r5c04nemp">
            <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-98" data-mp="39ogobmxy283q">
              <h2 className="font-display text-3xl tracking-[-0.02em] sm:text-4xl" data-id="element-99" data-mp="39mcn5crfjn75">
                {t.directory}
              </h2>
              <p className="font-mono text-[10px] uppercase tracking-label text-ink/45" data-id="element-100" data-mp="1eo88vrfgswt">
                {departments.length} {t.count}
              </p>
            </div>
            <ul className="mt-10 border-t border-ink" data-id="element-101" data-mp="3jqayync09lsh">
              {departments.map((item, index) => <li key={item.id} id={item.id} className="scroll-mt-24 border-b border-stone" data-id="element-102" data-mp="gbf630lgdwkb" data-mpi={index}>
                  <div className="group grid grid-cols-[3rem_1fr] items-center gap-5 py-5 sm:grid-cols-[3rem_5rem_1fr_1fr_auto] sm:gap-8" data-id="element-103" data-mp="kc7gvy9z49ip">
                    <span className="font-mono text-[11px] text-cobalt" data-id="element-104" data-mp="bc2anrginh64">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                    <img src={item.image} alt="" loading="lazy" className="hidden h-16 w-20 object-cover sm:block" data-id="element-105" data-mp="2r25b3rpnngof" />
                    <h3 className="font-display text-2xl leading-tight" data-id="element-106" data-mp="2jjxpn3j9jyyi">
                      {item.name[locale]}
                    </h3>
                    <p className="col-start-2 text-sm leading-6 text-ink/60 sm:col-start-4" data-id="element-107" data-mp="2xinksdmivok8">
                      {item.detail[locale]}
                    </p>
                    <Link to="/contact" className="col-start-2 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-label text-ink/60 hover:text-cobalt sm:col-start-5 sm:justify-self-end" data-id="element-108" data-mp="24v188fvbh9l8">
                      {t.request}
                      <ArrowUpRightIcon size={13} data-id="element-109" data-mp="29ue3np097ozf" />
                    </Link>
                  </div>
                </li>)}
            </ul>
          </div>
        </section>
      </main>
    </SiteLayout>;
}